(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    if (!format) format = '€{{amount_with_comma_separator}}';
    var amount      = (cents / 100).toFixed(2);
    var amountComma = amount.replace('.', ',');
    var amountApos  = amount.replace('.', '\u2019');
    var amountND    = String(Math.round(cents / 100));
    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_with_comma_separator}}', amountComma)
      .replace('{{amount_with_apostrophe_separator}}', amountApos)
      .replace('{{amount_no_decimals}}', amountND)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountND)
      .replace('{{amount_no_decimals_with_space_separator}}', amountND);
  }

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl._btInit) return;
    sectionEl._btInit = true;

    var sectionId   = sectionEl.dataset.sectionId || 'bt-default';
    var SESSION_KEY = 'bt_bundle_' + sectionId;
    var isAdding    = false;

    var products    = sectionEl.querySelectorAll('.bt-product');
    var ctaBtn      = sectionEl.querySelector('.bt-cta');
    var ctaTextEl   = sectionEl.querySelector('.bt-cta__text');
    var errorEl     = sectionEl.querySelector('.bt-error');
    var countEl     = sectionEl.querySelector('.bt-js-count');
    var totalEl     = sectionEl.querySelector('.bt-js-total');
    var originalEl  = sectionEl.querySelector('.bt-js-original');
    var savingsEl   = sectionEl.querySelector('.bt-js-savings');
    var saveRowEl   = savingsEl ? savingsEl.closest('.bt-summary__save-row') : null;
    var badgeEl     = sectionEl.querySelector('.bt-discount-badge');
    var mainProduct = sectionEl.querySelector('.bt-product--main');

    var moneyFormat      = sectionEl.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
    var discountEnabled  = sectionEl.dataset.discountEnabled === 'true';
    var discountPercent  = parseFloat(sectionEl.dataset.discountPercent) || 0;
    var discountCode     = sectionEl.dataset.discountCode || '';
    var totalCount       = parseInt(sectionEl.dataset.totalCount, 10) || 1;
    var companionCount   = parseInt(sectionEl.dataset.companionCount, 10) || 0;
    var loadingText      = sectionEl.dataset.loadingText || 'Зареждане...';
    var errorText        = sectionEl.dataset.errorText || 'Грешка при добавяне.';
    var unavailText      = sectionEl.dataset.unavailableText || 'Изчерпана наличност.';

    var origCtaText = ctaTextEl ? ctaTextEl.textContent : (ctaBtn ? ctaBtn.textContent : '');

    sectionEl.classList.add('bt-animate');
    setTimeout(function () {
      sectionEl.classList.add('bt-is-visible');
    }, 50);

    // ─── getChecked ────────────────────────────────────────────────────────────
    function getChecked() {
      return Array.from(products).filter(function (p) {
        var cb = p.querySelector('.bt-product__checkbox');
        return cb && cb.checked;
      });
    }

    // ─── updateSummary (FIXED) ─────────────────────────────────────────────────
    // Changes vs original:
    //   1. Single loop — sold-out enforcement, availability counting and rawTotal
    //      are all computed together so allChecked is never stale.
    //   2. allChecked is based on available products only, not the Liquid-rendered
    //      totalCount which may include sold-out companions.
    //   3. availableCompanionCount replaces the companionCount data-attribute for
    //      the discount gate, so a sold-out companion never blocks the discount
    //      for the remaining available products.
    //   4. hasSoldOut dead-code path removed; CTA is simply disabled when nothing
    //      is checked.
    function updateSummary() {
      var rawTotal                = 0;
      var availableCount          = 0;
      var availableCompanionCount = 0;
      var checkedCount            = 0;

      products.forEach(function (p) {
        var cb          = p.querySelector('.bt-product__checkbox');
        var isMain      = p.classList.contains('bt-product--main');
        var isAvailable = p.dataset.available === 'true';

        // Enforce sold-out visual + disable checkbox
        if (!isAvailable) {
          p.classList.add('bt-product--sold-out');
          if (cb) { cb.checked = false; cb.disabled = true; }
        } else {
          p.classList.remove('bt-product--sold-out');
          if (cb) cb.disabled = false;
          availableCount++;
          if (!isMain) availableCompanionCount++;
        }

        // Accumulate for checked + available items only
        if (cb && cb.checked && isAvailable) {
          checkedCount++;
          rawTotal += (parseInt(p.dataset.price, 10) || 0);
        }
      });

      // allChecked: every available product is selected
      var allChecked = (availableCount > 0) && (checkedCount === availableCount);

      // Discount: enabled in settings + non-zero percent + all available selected
      //           + at least one available companion present
      var hasDiscount = discountEnabled && discountPercent > 0 && allChecked && availableCompanionCount > 0;
      var finalTotal  = hasDiscount ? Math.round(rawTotal * (1 - discountPercent / 100)) : rawTotal;
      var savings     = rawTotal - finalTotal;

      // Update count and total price
      if (countEl) countEl.textContent = checkedCount;
      if (totalEl) totalEl.textContent = formatMoney(finalTotal, moneyFormat);

      // Original (struck-through) price
      if (originalEl) {
        originalEl.style.display = hasDiscount ? '' : 'none';
        if (hasDiscount) originalEl.textContent = formatMoney(rawTotal, moneyFormat);
      }

      // Savings row
      if (savingsEl && saveRowEl) {
        saveRowEl.style.display = hasDiscount ? '' : 'none';
        if (hasDiscount) savingsEl.textContent = formatMoney(savings, moneyFormat);
      }

      // Discount badge
      if (badgeEl) badgeEl.style.display = hasDiscount ? '' : 'none';

      // CTA state — only disabled when nothing is selected
      if (ctaBtn) {
        ctaBtn.disabled = (checkedCount === 0);
        if (!ctaBtn.classList.contains('bt-cta--loading') && ctaTextEl) {
          ctaTextEl.textContent = origCtaText;
        }
      }
    }

    // Attach change listeners
    products.forEach(function (p) {
      var cb = p.querySelector('.bt-product__checkbox');
      if (cb) cb.addEventListener('change', updateSummary);
    });

    // ─── Cart helpers ──────────────────────────────────────────────────────────
    function updateCartCount() {
      return fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll(
            '[data-cart-count], .cart-count, .js-cart-count, .cart-item-count, ' +
            '[data-item-count], .header__cart-count, .site-header__cart-count, ' +
            '#cart-icon-bubble span'
          ).forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.remove('hidden', 'd-none');
          });
        }).catch(function () {});
    }

    function rerenderCartDrawerHTML() {
      var cartComp = document.querySelector('cart-drawer-component, cart-drawer, [is="cart-drawer"]');
      var sId = cartComp && cartComp.dataset ? cartComp.dataset.sectionId : 'cart-drawer';
      if (!sId || !cartComp) return Promise.resolve();

      return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sId))
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (json) {
          if (!json || !json[sId]) return;
          var doc = new DOMParser().parseFromString(json[sId], 'text/html');

          ['[data-merge]', '[data-merge-list]'].forEach(function (selector) {
            document.querySelectorAll(selector).forEach(function (el) {
              var attr    = selector.replace('[', '').replace(']', '');
              var key     = el.getAttribute(attr);
              var freshEl = doc.querySelector('[' + attr + '="' + key + '"]');
              if (freshEl) el.innerHTML = freshEl.innerHTML;
            });
          });

          document.querySelectorAll('[data-merge-attributes]').forEach(function (el) {
            var key     = el.getAttribute('data-merge-attributes');
            var freshEl = doc.querySelector('[data-merge-attributes="' + key + '"]');
            if (freshEl) el.className = freshEl.className;
          });

          ['.cdr-shipping-bar', '.cart-info-block', '.cdr-trust-wrap'].forEach(function (sel) {
            var oldEl = document.querySelector(sel);
            var newEl = doc.querySelector(sel);
            if (oldEl && newEl) oldEl.innerHTML = newEl.innerHTML;
          });

          document.dispatchEvent(new CustomEvent('on:cart:after-merge', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        }).catch(function () {});
    }

    function openCartDrawerNatively() {
      var drawer = document.querySelector('cart-drawer-component, cart-drawer, [is="cart-drawer"]');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        var cartIcon = document.querySelector('.header__cart-link, #cart-icon-bubble, [data-cart-open]');
        if (cartIcon) cartIcon.click();
      }
      ['cart-add', 'cart:add', 'cart:updated', 'theme:cart:updated', 'cart-drawer:open', 'ajaxProduct:added'].forEach(function (name) {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true }));
      });
    }

    function applyDiscountCodeBackground() {
      if (!discountCode) return Promise.resolve();
      return fetch('/discount/' + encodeURIComponent(discountCode), {
        method: 'GET', credentials: 'include'
      }).catch(function () {});
    }

    // ─── CTA click ────────────────────────────────────────────────────────────
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        var checked = getChecked();
        if (checked.length === 0) return;

        // Guard: check real-time availability before submitting
        var unavailable = checked.filter(function (p) { return p.dataset.available === 'false'; });
        if (unavailable.length > 0) { showError(unavailText); return; }

        hideError();
        isAdding = true;

        var items = checked.map(function (p) {
          return {
            id:         parseInt(p.dataset.variantId, 10),
            quantity:   1,
            properties: { '_bt_bundle': sectionId }
          };
        });

        // allChecked at click-time (separate from updateSummary's allChecked)
        var availableAtClick = Array.from(products).filter(function (p) {
          return p.dataset.available === 'true';
        }).length;
        var allCheckedAtClick = checked.length === availableAtClick;

        ctaBtn.classList.add('bt-cta--loading');
        ctaBtn.disabled = true;
        if (ctaTextEl) ctaTextEl.textContent = loadingText;

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:    JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Възникна проблем при добавянето.');
            return res.json();
          })
          .then(function () { return updateCartCount(); })
          .then(function () { return rerenderCartDrawerHTML(); })
          .then(function () {
            // Only apply discount code when all available products were added
            // and a companion exists and a code is configured
            if (allCheckedAtClick && discountCode && companionCount > 0) {
              return applyDiscountCodeBackground().then(function () {
                sessionStorage.setItem(SESSION_KEY, '1');
                startPolling();
              });
            }
          })
          .then(function () {
            isAdding = false;
            openCartDrawerNatively();
            ctaBtn.classList.remove('bt-cta--loading');
            ctaBtn.disabled = false;
            if (ctaTextEl) ctaTextEl.textContent = origCtaText;
          })
          .catch(function () {
            isAdding = false;
            ctaBtn.classList.remove('bt-cta--loading');
            ctaBtn.disabled = false;
            if (ctaTextEl) ctaTextEl.textContent = origCtaText;
            showError(errorText);
          });
      });
    }

    // ─── Discount code polling ─────────────────────────────────────────────────
    var pollInterval = null;
    var isPolling    = false;

    function stopPolling() {
      if (pollInterval) { clearInterval(pollInterval); pollInterval = null; }
    }

    function startPolling() {
      if (window.Shopify && window.Shopify.designMode) return;
      if (pollInterval) return;
      isPolling    = true;
      pollInterval = setInterval(pollCart, 3000);
    }

    function clearDiscountCookie() {
      document.cookie = 'discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + window.location.hostname;
      fetch('/checkout?clear_discount=1', { method: 'GET', credentials: 'same-origin' })
        .then(function () {
          ['cart:refresh', 'cart-updated', 'theme:cart:refresh', 'cart:updated'].forEach(function (evt) {
            document.dispatchEvent(new CustomEvent(evt, { bubbles: true, composed: true }));
          });
          rerenderCartDrawerHTML();
        }).catch(function () {});
    }

    function pollCart() {
      if (isAdding) return;
      fetch('/cart.js?_t=' + new Date().getTime())
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart.items) return;
          var bundleItemCount = 0;

          cart.items.forEach(function (item) {
            if (item.properties && item.properties['_bt_bundle'] === sectionId) {
              bundleItemCount += item.quantity;
            }
          });

          if (bundleItemCount > 0 && bundleItemCount < totalCount) {
            clearDiscountCookie();
            sessionStorage.removeItem(SESSION_KEY);
            stopPolling();
            isPolling = false;
          } else if (bundleItemCount === 0) {
            sessionStorage.removeItem(SESSION_KEY);
            stopPolling();
            isPolling = false;
          }
        }).catch(function () {});
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopPolling();
      else if (isPolling) startPolling();
    });

    window.addEventListener('beforeunload', stopPolling);

    if (!sectionEl.dataset.listenersBound) {
      var handleCartUpdate = function () {
        if (isAdding) return;
        if (!sessionStorage.getItem(SESSION_KEY)) return;
        pollCart();
      };
      document.addEventListener('cart:updated', handleCartUpdate);
      document.addEventListener('cart-updated', handleCartUpdate);
      document.addEventListener('cart:refresh', handleCartUpdate);
      document.addEventListener('cart:change', handleCartUpdate);
      sectionEl.dataset.listenersBound = 'true';
    }

    // ─── Main product variant sync ─────────────────────────────────────────────
    if (mainProduct) {
      var productHandle = mainProduct.dataset.productHandle;
      var variantCache  = {};
      var fetchPending  = false;

      function applyVariant(variantId) {
        if (!variantId || !productHandle) return;
        var vid = String(variantId);
        if (variantCache[vid]) { applyVariantData(variantCache[vid]); return; }
        if (fetchPending) return;
        fetchPending = true;

        fetch('/products/' + productHandle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            (data.variants || []).forEach(function (v) { variantCache[String(v.id)] = v; });
            fetchPending = false;
            if (variantCache[vid]) applyVariantData(variantCache[vid]);
          })
          .catch(function () { fetchPending = false; });
      }

      function applyVariantData(variant) {
        mainProduct.dataset.variantId = variant.id;
        mainProduct.dataset.price     = variant.price;
        mainProduct.dataset.available = String(variant.available);

        var priceEl = mainProduct.querySelector('.bt-product__price');
        if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);

        updateSummary();
      }

      // Listen for native select[name="id"] changes (standard Shopify variant form)
      document.addEventListener('change', function (e) {
        if (e.target.name === 'id') applyVariant(e.target.value);
      });

      // Listen for theme variant change events
      ['variant:change', 'variant:changed', 'variant:update', 'variant:updated',
        'variantChange', 'variantChanged'].forEach(function (ev) {
        document.addEventListener(ev, function (e) {
          var d  = e.detail || {};
          var id = (d.variant && d.variant.id) || d.id || d.variantId || null;
          if (id) applyVariant(id);
        });
      });

      // Apply variant from URL on load
      var urlVariant = new URLSearchParams(window.location.search).get('variant');
      if (urlVariant) applyVariant(urlVariant);
    }

    // ─── Error helpers ─────────────────────────────────────────────────────────
    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent   = msg;
      errorEl.style.display = '';
    }

    function hideError() {
      if (!errorEl) return;
      errorEl.style.display = 'none';
      errorEl.textContent   = '';
    }

    // ─── Init ──────────────────────────────────────────────────────────────────
    updateSummary();
  }

  function destroySection(sectionEl) {
    if (!sectionEl) return;
    if (sectionEl._btVisObs) {
      sectionEl._btVisObs.disconnect();
      sectionEl._btVisObs = null;
    }
    sectionEl._btInit = false;
  }

  // ─── Shopify section lifecycle ─────────────────────────────────────────────
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.bt-section');
    if (el) { el._btInit = false; initSection(el); }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    destroySection(e.target.querySelector('.bt-section'));
  });

  // ─── Boot all existing sections ────────────────────────────────────────────
  document.querySelectorAll('.bt-section').forEach(initSection);

}());
